import { environment } from "src/environments/environment";


export const globals = {
  //langOptions: false
  // FACEBOOK_APP_KEY: 193733682579063,
  // GOOGLe_KEY: '950151449917-ffhasusm9j3tf99cc2qd7ut4ne9fdql9.apps.googleusercontent.com',
  FACEBOOK_APP_KEY: 0,
  GOOGLe_KEY: 0,
  //Workaround for production
  site: environment.baseURL,
  // Razorpay_Return_URL: '',
  // destinationURL: 'BNfH6qcZqpG7olI+SCFuwupI7IB4a/Vd5rnt/Nk0CggZfEktOZhITQ==', //preprod
  // doubleOptinUrl: 'http://stagingdoubleoptin.9mobile.com.ng',
  // playbackTimeEndpoint: 'http://10.161.38.24:9200/'
  playbackTimeEndpoint:''
}